import {
  CREATE_ADMIN,
  CREATE_ADMIN_FAILURE,
  CREATE_ADMIN_SUCCESS,
  DELETE_ADMIN,
  DELETE_ADMIN_FAILURE,
  DELETE_ADMIN_SUCCESS,
  GET_ADMINS,
  GET_ADMINS_FAILURE,
  GET_ADMINS_SUCCESS,
  GET_ADMIN,
  GET_ADMIN_FAILURE,
  GET_ADMIN_SUCCESS,
  UPDATE_ADMIN,
  UPDATE_ADMIN_FAILURE,
  UPDATE_ADMIN_SUCCESS,
} from "./actionTypes";

const initialState = {
  admins: [],
  admin: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const admins = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINS:
      return {
        ...state,
        loading: true,
      };

    case GET_ADMINS_SUCCESS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      };

    case GET_ADMINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case GET_ADMIN:
      return {
        ...state,
        loading: true,
      };

    case GET_ADMIN_SUCCESS:
      return {
        ...state,
        admin: action.payload,
        loading: false,
      };

    case GET_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case CREATE_ADMIN:
      return {
        ...state,
        loading: true,
      };

    case CREATE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: [...state.admins, action.payload],
        loading: false,
      };

    case CREATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_ADMIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.map((admin) =>
          admin._id === action.payload._id ? action.payload : admin
        ),
        loading: false,
      };

    case UPDATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case DELETE_ADMIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.filter((admin) => admin.id !== action.payload?.id),
        loading: false,
      };

    case DELETE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default admins;
